import "../scss/app.scss";

// SVGs to make into sprite, paths relative to app.js before move
var __svg__ = {
	path: "../svgs/sprite/*.svg",
	name: "../../flyingoxygen/jinja2/svgs/sprite.svg"
};

import { AjaxForm } from "@neonjungle/birdseed/forms/ajax";

import menuActions from "./includes/menuActions";


document.addEventListener("DOMContentLoaded", function() {
	menuActions();

	document.body.classList.remove("preload");

	let mailchimpForm = document.querySelector("[data-mailchimp-form]");
	if (mailchimpForm) new AjaxForm(mailchimpForm);
});
